import { get, set, del, clear } from "idb-keyval";

/**
 * Persistent storage adapter for Supabase auth using IndexedDB
 * This ensures auth sessions persist across browser sessions and app restarts
 */
export class PersistentStorage {
  private storageKey = "supabase.auth.token";

  async getItem(key: string): Promise<string | null> {
    try {
      const value = await get<string>(`${this.storageKey}.${key}`);
      return value ?? null;
    } catch (error) {
      console.error("Error getting item from persistent storage:", error);
      return null;
    }
  }

  async setItem(key: string, value: string): Promise<void> {
    try {
      await set(`${this.storageKey}.${key}`, value);
    } catch (error) {
      console.error("Error setting item in persistent storage:", error);
    }
  }

  async removeItem(key: string): Promise<void> {
    try {
      await del(`${this.storageKey}.${key}`);
    } catch (error) {
      console.error("Error removing item from persistent storage:", error);
    }
  }

  async clear(): Promise<void> {
    try {
      await clear();
    } catch (error) {
      console.error("Error clearing persistent storage:", error);
    }
  }
}

export const persistentStorage = new PersistentStorage();
